/** 採購單／物料／進貨：PDF／JPEG／PNG */
export const ATTACHMENT_POLICY_STANDARD = {
  id: 'STANDARD',
  accept: '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png',
  label: 'PDF、JPEG、PNG',
};

/** 進貨單（RECEIPT）：同 STANDARD */
export const ATTACHMENT_POLICY_RECEIPT = {
  id: 'RECEIPT',
  accept: ATTACHMENT_POLICY_STANDARD.accept,
  label: ATTACHMENT_POLICY_STANDARD.label,
};

/** 客戶訂單／銷貨單：另可 Excel（僅下載，不可預覽） */
export const ATTACHMENT_POLICY_SPREADSHEET = {
  id: 'SPREADSHEET',
  accept: [
    '.pdf',
    '.jpg',
    '.jpeg',
    '.png',
    '.xls',
    '.xlsx',
    'application/pdf',
    'image/jpeg',
    'image/png',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ].join(','),
  label: 'PDF、JPEG、PNG、Excel',
};

const PREVIEWABLE_TYPES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/jpg',
]);

/**
 * @param {string | null | undefined} contentType
 * @param {string | null | undefined} [filename]
 */
export function canPreviewAttachment(contentType, filename) {
  const type = String(contentType || '').toLowerCase().split(';')[0].trim();
  if (PREVIEWABLE_TYPES.has(type)) {
    return true;
  }
  const name = String(filename || '').toLowerCase();
  return (
    name.endsWith('.pdf')
    || name.endsWith('.jpg')
    || name.endsWith('.jpeg')
    || name.endsWith('.png')
  );
}

/**
 * @param {string | null | undefined} contentType
 * @param {string | null | undefined} [filename]
 */
export function isPdfAttachment(contentType, filename) {
  const type = String(contentType || '').toLowerCase();
  if (type.includes('pdf')) {
    return true;
  }
  return String(filename || '').toLowerCase().endsWith('.pdf');
}

/**
 * @param {string | null | undefined} contentType
 * @param {string | null | undefined} [filename]
 */
export function isImageAttachment(contentType, filename) {
  const type = String(contentType || '').toLowerCase();
  if (type.startsWith('image/')) {
    return true;
  }
  const name = String(filename || '').toLowerCase();
  return name.endsWith('.jpg') || name.endsWith('.jpeg') || name.endsWith('.png');
}
